import { render, staticRenderFns } from "./item2.vue?vue&type=template&id=69148ebe&scoped=true"
import script from "./item2.vue?vue&type=script&lang=js"
export * from "./item2.vue?vue&type=script&lang=js"
import style0 from "./item2.vue?vue&type=style&index=0&id=69148ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69148ebe",
  null
  
)

export default component.exports